import { PageType, useCurrentPageType } from 'Client/hooks/UrlManager/pageTypeHooks';

type HeaderModeType = 'default' | 'mini' | 'none';

export const useLayoutByPage = () => {
    const { pageType } = useCurrentPageType();
    const isCartPage = [PageType.CART_NATIVE, PageType.CART].includes(pageType);

    let headerMode: HeaderModeType;
    switch (pageType) {
        case PageType.CART_NATIVE:
            headerMode = 'none';
            break;
        case PageType.CART:
            headerMode = 'mini';
            break;
        default:
            headerMode = 'default';
    }

    return {
        shouldRenderHeader: pageType !== PageType.CART_NATIVE, // TODO: delete this
        shouldRenderFooter: !isCartPage, // TODO: refactor to footer mode
        headerMode,
    };
};
